import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';

interface PreClaimsInitialValuesApi {
  claimKey: number;
  carrierKey: number;
  branchKey: number;
  claimNumber: null;
  invoiceNo: null;
  claimProNo: null;
  claimTypeKey: number;
  claimStatusCode: 'P';
  reasonType: string;
  reasonCode: string;
  consigneeKey: number;
  consigneeShortName: null;
  consigneeName: null;
  consigneeAddr1: null;
  consigneeAddr2: null;
  consigneeCity: null;
  consigneeState: null;
  consigneeZip: null;
  consigneeCountry: string;
  originKey: number;
  shipperShortName: null;
  shipperName: null;
  shipperAddr1: null;
  shipperAddr2: null;
  shipperCity: null;
  shipperState: null;
  shipperZip: null;
  shipperCountry: string;
  cargoShipmentWeight: number;
  dateFiled: string; // '2025-04-14T00:00:00+00:00'
  dateShipped: null;
  claimNoOfPieces: null;
  salvageAmount: null;
  markdownAmount: null;
  repairCostAmount: null;
  currencyCode: string;
  createdBy: number;
  createdOn: null;
  modifiedBy: null;
  modifiedOn: null;
  claimItem: null;
  claimComment: null;
  claimFile: null;
  bypassClaimItemTotal: string;
  bypassClaimItemWeight: string;
  claimInterestRate: number;
  inspectorRate: number;
  laborRate: number;
  processingCostFrom: string;
  processingCostTo: string;
  adminFees: number;
  baseCurrency: null;
  displayIndemnityNotes: null;
  displayAPNumber: null;
  displaySealNumber: null;
  displaySealIntact: null;
  displayDifferentCheckPayableAddress: null;
  displayEmailInPrintReport: null;
  sendEmailOthers: null;
  defaultItemUOM: null;
  documentationAddressEnabled: null;
}

export const getPreClaimsInitialValuesAPI = () => {
  return axiosInstance.request({
    url: `${API.PRECLAIM}/GetInitialClaimData`,
    method: 'get',
  });
};

export type PreClaimsInitialValuesResponse = PreClaimsInitialValuesApi;

export const fetchPreClaimsInitialValues = async (): Promise<PreClaimsInitialValuesResponse> => {
  const response: AxiosResponse<PreClaimsInitialValuesResponse> = await getPreClaimsInitialValuesAPI();
  return response.data;
};
